<div class="flex items-center">
  <div class="flex overflow-hidden rounded-lg">
    <button
      *ngIf="icon"
      [disabled]="isDisabled"
      class="border-none flex justify-center items-center p-2 px-4 rounded-none border-r"
      [ngClass]="iconClassNames"
    >
      <mat-icon style="font-size: 20px">add</mat-icon>
    </button>

    <button
      type="button"
      class="button-icon flex items-center p-2 px-4 rounded-none"
      [ngClass]="classNames"
      (click)="trigger(value)"
    >
      <span *ngIf="name">{{ name }}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
</div>
